type DataLayerEvent = {
  event: "orIdentify" | "orTrack"
  eventName?: string
  properties?: any
  traits?: any
  uid?: string
}

// DataLayer declaration
declare global {
  interface Window {
    dataLayer?: DataLayerEvent[]
  }
}

export default function useGtm({
  event,
  eventName,
  properties,
  traits,
  uid,
}: DataLayerEvent) {

  console.log("Use GTM Event:", {
    event,
    ...(eventName && { eventName }),
    ...(properties && { properties }),
    ...(traits && { traits }),
    ...(uid && { uid }),
  })

  if (typeof window === "undefined") {
    return
  }

  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    event,
    ...(eventName && { eventName }),
    ...(properties && { properties }),
    ...(traits && { traits }),
    ...(uid && { uid }),
  })
}
